import "phaser";
import { cst } from "../helpers/cst";
import { path } from "../helpers/map.js";
import { Controller } from "../controller/controller.js";
import { Player } from "../model/player";
import config from "../helpers/config.js";
import buttonBehaviours from "../helpers/button-behaviours";

export default class Board extends Phaser.Scene {
  constructor() {
    super(cst.scenes.board);
  }

  init(data) {
    this.categories = data.categories;
  }

  create() {
    this.cameras.main.pan(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2 - 480,
      1
    );

    let coordinates = [];
    this.input.on("pointerdown", function (pointer) {
      coordinates.push([Math.round(pointer.x), Math.round(pointer.y)]);
    });

    this.squares = path;
    this.end = false;

    setTimeout(() => {
      this.cameras.main.pan(this.cameras.main.width / 2, 2078, 1500);
    }, 500);

    setTimeout(() => {
      this.cameras.main
        .startFollow(this.playerImage, true, undefined, undefined, 0, 0)
        .zoomTo(2);
      setTimeout(() => {
        this.scene.launch(cst.scenes.gui, this);
      }, 1200);
    }, 3000);

    if (config.numberCategories >= 2) {
      this.categoriesLog = {};
      this.categories.forEach((category) => {
        this.categoriesLog[`${category}`] = { questions: 0, correct: 0 };
      });
    }

    this.controller = new Controller(this);
    if (config.online) this.controller.logActivity();
    this.controller.loadQuestions();

    this.sndCongratulations = this.sound.add("snd-congratulations");
    this.sndPawn = this.sound.add("snd-pawn-movement", {
      volume: 0.5,
    });
    this.sndRoll = this.sound.add("snd-roll", {
      volume: 0.5,
    });
    this.sndPop = this.sound.add("snd-pop", {
      volume: 0.5,
    });

    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2 - 300,
      "bg-board"
    );

    this.cameras.main.setBounds(0, -490, 768, 1726); //1726
    this.playerImage = this.add
      .sprite(187, 1000, "pawn")
      .setDepth(2)
      .setScale(0.6);
    this.player = new Player(this.playerImage, 0, 0);

    this.scoreBox = this.add
      .image(
        this.cameras.main.width / 2 + 259,
        this.cameras.main.height / 2 - 455,
        "box-score"
      )
      .setScale(0.3)
      .setVisible(false)
      .setScrollFactor(0);

    this.txtScore = this.add
      .text(
        this.cameras.main.width / 2 + 265,
        this.cameras.main.height / 2 - 455,
        "Score:" + this.player.score,
        cst.textstyles.points
      )
      .setOrigin(0.5)
      .setVisible(false)
      .setScrollFactor(0);

    this.btnRules = this.add
      .image(
        this.cameras.main.width / 2 + 270,
        this.cameras.main.height / 2 + 430,
        "btn-rules"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnRules, () => {
          this.scene.pause();
          this.scene.launch(cst.scenes.rules, {
            scene: cst.scenes.board,
          });
        });
      })
      .setScale(1)
      .setVisible(false)
      .disableInteractive()
      .setScrollFactor(0);

    this.btnPause = this.add
      .image(
        this.cameras.main.width / 2 - 270,
        this.cameras.main.height / 2 + 430,
        "btn-pause"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnPause, () => {
          this.scene.pause();
          this.scene.launch(cst.scenes.pause, {
            scene: this,
          });
        });
      })
      .setScale(1)
      .setVisible(false)
      .disableInteractive()
      .setScrollFactor(0);

    this.boxDice = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 100,
        "box-dice"
      )
      .setScale(0.6)
      .setVisible(false)
      .setScrollFactor(0);

    this.dice = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 100,
        "sprite-dice"
      )
      .setScale(0.8)
      .setVisible(false)
      .setScrollFactor(0);

    this.chest = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 100,
        "win-sprite"
      )
      .setScale(0.8)
      .setVisible(false)
      .setScrollFactor(0);

    this.btnRoll = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 415,
        "btn-roll"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnRoll, () => {
          this.controller.rollDice();
        })
      )
      .setVisible(false)
      .disableInteractive()
      .setScrollFactor(0, 0);

    // Animations
    this.anims.create({
      key: "sprite-dice-roll",
      frames: this.anims.generateFrameNames("sprite-dice-roll"),
      frameRate: 8,
      repeat: 1,
    });

    this.anims.create({
      key: "win-sprite",
      frames: this.anims.generateFrameNames("win-sprite"),
      frameRate: 8,
      repeat: 0,
    });

    // On resume event
    this.events.on("resume", (scene, data) => {
      this.scene.resume(cst.scenes.gui, this);

      // this.scene.bringToTop();
      if (data.showChest == true) {
        this.chest.setVisible(true);
        this.chest.play("win-sprite");
        setTimeout(() => {
          this.chest.setVisible(false);
        }, 1500);
      }

      if (data.scene !== cst.scenes.rules && data.scene !== cst.scenes.pause) {
        // this line causes error sometimes
        if (config.numberCategories >= 2) {
          this.categoriesLog[`${data.category}`].questions++;
        }

        if (data.isCorrect) {
          this.player.score = this.player.score + data.points;
          this.txtScore.text = "Score: " + this.player.score;

          // this line causes error
          if (config.numberCategories >= 2) {
            this.categoriesLog[`${data.category}`].correct++;
          }
        }

        if (this.end) {
          this.controller.fireworks(false);
        } else {
          this.btnRoll.setTexture("btn-roll");
          this.btnRoll.setInteractive();
          this.btnRules.setInteractive();
          this.btnPause.setInteractive();
        }
      }
    });
  }

  update() {}
}
